import { useState } from 'react';
import OrdersIcon from '../../../assets/icons/Orders.svg'
import WishlistIcon from '../../../assets/icons/Heart.svg'
import SignOutIcon from '../../../assets/icons/SignOut.svg'
import InfoIcon from '../../../assets/icons/User.svg'
import SizingIcon from '../../../assets/icons/Sizing.svg'
import classes from './PersonalInfo.module.scss';
import MyOrders from './MyOrders/MyOrders';
// import Wishlist from '../Wishlist/Wishlist';
import MyInfo from './MyInfo/MyInfo';
import Sizing from './Sizing/Sizing';

export default function PersonalInfo() {

    const [activeComponent, setActiveComponent] = useState("myOrders");

    const NavigationOptions = [
        {
            id: "myOrders",
            title: "My Orders",
            image: OrdersIcon,
            component: <MyOrders />
        },
        // {
        //     id: "wishlist",
        //     title: "Wishlist",
        //     image: WishlistIcon,
        //     component: <Wishlist />
        // },
        {
            id: "myInfo",
            title: "My Info",
            image: InfoIcon,
            component: <MyInfo />
        },
        {
            id: "sizing",
            title: "Sizing",
            image: SizingIcon,
            component: <Sizing />
        },
        {
            id: "signOut",
            title: "Sign Out",
            image: SignOutIcon,
        },
    ]

    const displayComponentFromId = (optionId) => {
        switch (optionId) {
            case "myOrders": {
                return <MyOrders />
            }
            // case "wishlist": {
            //     return <Wishlist />
            // }
            case "myInfo": {
                return <MyInfo />
            }
            case "sizing": {
                return <Sizing />
            }
            default: {
                return <MyInfo />
            }
        }
    }

    return (
        <>
            {/* <div className={classes.NavHeader}>&nbsp;</div> */}
            <div className={classes.ProfileContainer}>
                <div className={classes.ProfileNavigatorContainer}>
                    <div className={classes.HeroHeader}>Hello Noor</div>
                    {/* <div className={classes.HeaderSubText}>Welcome to your Account</div> */}
                    <div className={classes.ProfileNavigatorOptionsContainer}>
                        {NavigationOptions.map(({ title, image, id }) => (
                            <div className={`${classes.ProfileOption} ${id === activeComponent ? classes.ActiveOption : ''}`} onClick={() => setActiveComponent(id)}>
                                <img className={classes.ProfileOptionImage} src={image} alt="profile navigation option" />
                                <div className={classes.ProfileOptionTitle}>{title}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={classes.ProfileComponentContainer}>
                    {displayComponentFromId(activeComponent)}
                </div>
            </div>
        </>
    )
}
